import script from "./device.vue?vue&type=script&lang=ts&setup=true"
export * from "./device.vue?vue&type=script&lang=ts&setup=true"

import "./device.vue?vue&type=style&index=0&id=fe636102&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/qiyexinxi_app-after-sales_prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fe636102"]])

export default __exports__